<script setup lang="ts">
import Modal from './Modal.vue'
import type { OperatorScriptData } from '@/composables/useOperatorScript'

defineProps<{
  modelValue: boolean
  script: OperatorScriptData | null
}>()

const emit = defineEmits<{
  (e: 'accept'): void
  (e: 'decline'): void
}>()
</script>

<template>
  <Modal
    :modelValue="modelValue"
    modalName="operatorScript"
    :modalSize="script?.modalSize ?? ''"
    :centeredVertically="script?.centeredVertically ?? false"
    :tempOperatorScriptVue="true"
    @close="emit('decline')"
  >
    <template #header>
      <h5 class="modal-title">
        <em v-if="script?.headerIcon" :class="script.headerIcon" />&nbsp;{{ script?.header }}
      </h5>
    </template>

    <template #body>
      <div v-if="script?.body" v-html="script.body" />
    </template>

    <template #footer>
      <button
        v-if="script?.showCancel"
        type="button"
        :class="script?.cancelButtonClass || 'btn btn-secondary'"
        @click="emit('decline')"
      >
        {{ script?.declineButtonText || 'Cancel' }}
      </button>
      <button
        v-if="script?.showOk"
        type="button"
        :class="script?.okButtonClass || 'btn btn-primary'"
        @click="emit('accept')"
      >
        {{ script?.acceptButtonText || 'Continue' }}
      </button>
    </template>
  </Modal>
</template>
